import { DEFAULT_SEGMENT_SIZE } from '../constants.js';

export const getLabelEndPosition = (
  endPosition: number,
  isSinglePointRange: boolean,
  isLastItem: boolean,
) =>
  isSinglePointRange && !isLastItem
    ? endPosition + DEFAULT_SEGMENT_SIZE / 2
    : endPosition;
